const Notification = () => import("./views/Notifications.vue")

const routes = [
  {
    path: '/notifications',
    name: 'notifications',
    component: Notification
  }
]

export default router => {
  routes.forEach(element => {
    router.addRoute('main', element);
  })
};